import { useEffect, useState } from "react";

import Snackbar from "@mui/material/Snackbar";

function OnlineTracker() {
  const [state, set] = useState({ open: false, message: null });

  useEffect(() => {
    function cbWhenOnline() {
      set({ open: true, message: "You are online!!" });
    }
    function cbWhenOffline() {
      set({
        open: true,
        message: "No Internet!!",
      });
    }
    window.addEventListener("online", cbWhenOnline);
    window.addEventListener("offline", cbWhenOffline);

    return () => {
      window.removeEventListener("online", cbWhenOnline);
      window.removeEventListener("offline", cbWhenOffline);
    };
  }, []);

  return (
    <Snackbar
      open={state.open}
      autoHideDuration={6000}
      onClose={() =>
        set(
          (s) => ({ ...s, open: false }),
          false,
          "OnlineTracker : snackbar close",
        )
      }
      message={`${state.message}`}
    />
  );
}

export default OnlineTracker;
